import React from 'react';
import { Box, Text, Flex, Image, useMediaQuery } from '@chakra-ui/react';

import TopBanner from '../../assets/images/top-banner.jpg';
import Image01 from '../../assets/images/hedef-500bin_5_copy_2-01.svg';
import Image02 from '../../assets/images/hedef-500bin_5_copy_2-02.svg';
import Image03 from '../../assets/images/hedef-500bin_5_copy_2-03.svg';
import Image04 from '../../assets/images/hedef-500bin_5_copy_2-04.svg';
import Image05 from '../../assets/images/hedef-500bin_5_copy_2-05.svg';
import Image06 from '../../assets/images/hedef-500bin_5_copy_2-06.svg';
import Image07 from '../../assets/images/hedef-500bin_5_copy_2-07.svg';
import Image08 from '../../assets/images/hedef-500bin_5_copy_2-08.svg';

const NumberBox = ({ src }) => (
    <Flex
        backgroundPosition="center"
        backgroundSize="cover"
        color="white"
        mx={0}
        alignItems="center"
        justifyContent="center"
        fontWeight="bold"
        fontSize={{ base: '10px', md: '20px', lg: '40px' }}
    >
        {src && <Image width={{ base: 8, md: 10, lg: 20 }} src={src} />}
    </Flex>
);

export default function HomeCountdown() {
    const [isLargerThan1280] = useMediaQuery('(min-width: 960px)');
    return (
        <Flex
            flexDirection="column"
            backgroundImage={`url(${TopBanner})`}
            backgroundSize="cover"
            height={{ base: '450px', md: '600px', lg: '600px' }}
            textAlign="center"
            backgroundPosition="center"
            alignItems="center"
        >
            <Text fontSize="xl" mt={{ base: '10px', md: '30px', lg: '30px' }}>
                500.000 tohum topunu, drone’lar yardımıyla ve sizlerin desteğiyle doğal ortamlarına
                bırakıyoruz.
            </Text>
            <Box mt="auto" mb={10}>
                {isLargerThan1280 ? (
                    <Flex>
                        <NumberBox src={Image01} />
                        <NumberBox src={Image02} />
                        <NumberBox src={Image03} />
                        <NumberBox src={Image04} />
                        <NumberBox src={Image05} />
                        <NumberBox src={Image07} />
                        <NumberBox src={Image06} />
                        <NumberBox src={Image08} />
                        <NumberBox src={Image08} />
                        <NumberBox src={Image08} />
                        <NumberBox src={Image08} />
                        <NumberBox src={Image08} />
                    </Flex>
                ) : (
                    <>
                        <Flex justifyContent="center">
                            <NumberBox src={Image01} />
                            <NumberBox src={Image02} />
                            <NumberBox src={Image03} />
                            <NumberBox src={Image04} />
                            <NumberBox src={Image05} />
                        </Flex>
                        <Flex justifyContent="center">
                            <NumberBox src={Image06} />
                            <NumberBox src={Image08} />
                            <NumberBox src={Image08} />
                            <NumberBox src={Image08} />
                            <NumberBox src={Image08} />
                            <NumberBox src={Image08} />
                        </Flex>
                    </>
                )}
            </Box>
        </Flex>
    );
}
